<template>
  <div class="convenienceServe">
    <div class="header">
      <div class="banner">
        <img src="@/assets/index/convenienceServe/dpsy-banner.png" alt />
        <button @click="goGrid">进入网格服务</button>
      </div>
      <div class="title">一键预约办事</div>
      <div class="thing-box">
        <div
          class="thing-template"
          v-for="thing in things"
          :key="thing.name"
          @click="goApp(thing.name)"
        >
          <img :src="thing.imgUrl" alt />
          <p>{{thing.name}}</p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">政策服务信息</div>
      <div class="news-list">
        <div
          class="news-template"
          v-for="(news,index) in sevenLine"
          :key="index"
          @click="goDetail(news.c4idd)"
        >
          <div class="news-left">
            <img :src="news.imgUrl" alt v-if="news.imgUrl==null?false:true" />
          </div>
          <div class="news-right">
            <p>{{news.c4headline}}</p>
            <p>
              <!-- <span style="margin-right:.5rem;">浏览:{{news.sees}}</span>
              <span>点赞:{{news.praise}}</span> -->
              <span style="margin-right:.3rem;float:right">{{news.c4createtime|times}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      things: [
        {
          imgUrl: require("@/assets/index/convenienceServe/dp-sy-bm3.png"),
          name: "惠农政策"
        },
        {
          imgUrl: require("@/assets/index/convenienceServe/dp-sy-bm4.png"),
          name: "低保政策"
        },
        {
          imgUrl: require("@/assets/index/convenienceServe/dp-sy-bm5.png"),
          name: "医保政策"
        },
        {
          imgUrl: require("@/assets/index/convenienceServe/dp-sy-bm6.png"),
          name: "社会救助"
        },
        {
          imgUrl: require("@/assets/index/convenienceServe/dp-sy-bm7.png"),
          name: "其它"
        }
      ],
      sevenLine: []
    };
  },
  mounted() {
    this.getMsg()
  },
  methods: {
    goApp(value) {
      if (sessionStorage.getItem("roleid") == 6) {
        alert("游客无法使用该功能");
        return;
      }
      this.$router.push({
        path: "appointment",
        query: { title: "一键预约办事", value: value }
      });
    },
    goDetail(newsid) {
      this.$router.push({
        path: "publicDetail",
        query: {
          title: "新闻动态",
          id: newsid,
          dbnum: 1
        }
      });
    },
    goGrid(){
      if (sessionStorage.getItem("roleid") == 6) {
        alert("游客无法使用该功能");
        return;
      }
      this.$router.push({path:'/gridservice',query:{title:'网格服务'}})
    },
    getMsg(){
      this.axios.get(
        `/api/Main/Service?township=${sessionStorage.getItem('township')}`
      ).then(e=>{
        switch (e.data.code) {
          case 0:
            console.log(e.data);
            this.sevenLine = e.data.msg
            break;
        
          default:
            break;
        }
        
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.convenienceServe {
  .content {
    .title {
      margin-top: 0.3rem;
      line-height: 3;
      font-weight: bold;
      font-size: 0.36rem;
      background: #fff;
      padding-left: 0.2rem;
    }
    .news-list {
      .news-template {
        width: 94%;
        margin: 0 auto;
        display: flex;
        margin-bottom: 0.2rem;
        background: #fff;
        padding: 0.2rem 0;
        border-radius: 0.16rem;
        //   align-items: center;
        .news-right {
          width: 100%;
          margin-left: 0.2rem;
          p:nth-child(1) {
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            margin-bottom: 0.3rem;
            line-height: 1.8;
          }
          p:nth-child(2) {
            border-top: 0.01rem solid #e6e6e6;
            padding-top: 0.2rem;
            color: #999999;
            font-size: 0.26rem;
          }
        }
        .news-left {
          img {
            width: 2.4rem;
            height: 2rem;
          }
        }
      }
      margin-top: 0.3rem;
    }
  }
  .header {
    width: 100%;
    margin: 0 auto;
    padding-top: 0.3rem;
    background: #fff;
    .thing-box {
      padding-bottom: 0.2rem;
      .thing-template {
        p {
          // text-align: center;
          position: relative;
          padding-bottom: 0.2rem;
          padding-left: 0.2rem;
          &::before {
            content: "";
            position: absolute;
            width: 25%;
            height: 0.06rem;
            border-radius: 0.04rem;
            bottom: 0.1rem;
            background: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
          }
        }
        img {
          width: 100%;
          height: 1.8rem;
          display: block;
        }
        margin-left: 0.3rem;

        width: 25%;
        display: inline-block;
        box-shadow: 0px 0.04rem 0.04rem 0px rgba(0, 0, 0, 0.08);
      }
      margin-right: 0.2rem;
      white-space: nowrap;
      overflow-x: scroll;
    }
    .title {
      line-height: 3;
      font-weight: bold;
      font-size: 0.36rem;
      width: 94%;
      margin: 0 auto;
    }

    .banner {
      button {
        position: absolute;
        padding: 0.1rem 0.2rem;
        font-size: 0.28rem;
        color: #fff;
        border: none;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
        right: 10%;
        top: 25%;
      }
      img {
        width: 100%;
      }
      width: 94%;
      margin: 0 auto;
    }
    position: relative;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>
